export function cumulativeOffset(target: HTMLElement): { top: number; left: number; } {
  let top = 0;
  let left = 0;
  let element: HTMLElement | null = target;
  do {
    top += element.offsetTop || 0;
    left += element.offsetLeft || 0;
    element = element.offsetParent as HTMLElement | null;
  } while (element);

  return { top, left };
}

export function setBodyModal(showModal: boolean): void {
  if (showModal) {
    document.body.classList.add('disable-scroll');
  } else {
    document.body.classList.remove('disable-scroll');
  }
}
